var ConditionalClickPlacement;
(function (ConditionalClickPlacement) {
    ConditionalClickPlacement["FIRST"] = "FIRST";
    ConditionalClickPlacement["SECOND"] = "SECOND";
})(ConditionalClickPlacement || (ConditionalClickPlacement = {}));
export default ConditionalClickPlacement;
